<kendo-tilelayout [columns]="8" [resizable]="true" [reorderable]="true">
  <kendo-tilelayout-item *ngFor="let item of tiles" [col]="item.col" [colSpan]="item.colSpan">
    <kendo-tilelayout-item-header>

      <casi-tile-header [tile]="item" (onCloseTile)="closeTile($event)" (onAddTile)="addToTile($event)"
        (onShowMenu)="showMenu($event)">
      </casi-tile-header>

    </kendo-tilelayout-item-header>
    <!-- <ng-container *ngComponentOutlet="item.componentActual" /> -->
    <ng-container *ngComponentOutlet="item.componentActual; inputs: getInputs(item);" />
    <!-- <kendo-tilelayout-item-body>
    </kendo-tilelayout-item-body> -->

  </kendo-tilelayout-item>
</kendo-tilelayout>
